import apiClient from 'services/api/client';

const getListingBase = () => {
  if (typeof window !== 'undefined' && window.LISTING_URL) {
    return String(window.LISTING_URL).replace(/\/$/, '');
  }
  return String(process.env.REACT_APP_LISTING_URL || 'https://listings.bxiworld.com').replace(/\/$/, '');
};

/**
 * Standalone Listing Journey app URL (seller hub / list products).
 *
 * SECURITY (VAPT rescan PT-25): the raw JWT is NO LONGER placed in the URL. The
 * seamless handoff now uses a short-lived single-use code minted server-side
 * (see goToListingApp). This builder only ever produces a token-free URL; use it
 * for a static href fallback, but the real handoff goes through goToListingApp.
 */
export const getListingAppUrl = (path = '/sellerhub', extraParams = {}) => {
  const normalized = getListingBase();
  const p = path.startsWith('/') ? path : `/${path}`;
  const params = { source: 'dashboard', ...extraParams };
  const q = new URLSearchParams(params);
  return `${normalized}${p}?${q.toString()}`;
};

/**
 * Redirect to the Standalone Listing app (seller hub) with a secure handoff.
 *
 * Mints a single-use authorization code on the server and passes it as `?code=`
 * (never the JWT). The Seller Hub exchanges it once for its own session. If the
 * code cannot be minted (e.g. offline), we fall back to a token-free URL — the
 * Seller Hub will then require its own login rather than leaking a token.
 *
 * @param {Object} [queryParams] - Optional query params (merged with source=dashboard)
 */
export const goToListingApp = async (queryParams = {}) => {
  let code = null;
  try {
    const res = await apiClient.post('auth/handoff/create', {});
    code = res?.data?.code || null;
  } catch (e) {
    // Non-fatal: fall through to a token-free redirect.
  }
  const url = getListingAppUrl('/sellerhub', {
    ...queryParams,
    ...(code ? { code } : {}),
  });
  window.location.href = url;
};
